"use client";

import React from 'react';
import './Testimonials.css';
import image01 from "../assets/roberta_araujo.webp";
import image02 from "../assets/altino_teixeira.webp";
import image03 from "../assets/natalia_campos.webp";
import image04 from "../assets/fabiola_alves.webp";
import image05 from "../assets/fabricio_penha.webp";
import image06 from "../assets/mayra_jinkings.webp";
import image07 from "../assets/juliana_machado.webp";
import image08 from "../assets/carlos_carvalho.webp";
import image09 from "../assets/gustavo_ferreira.webp";

import { Carousel, Typography } from "@material-tailwind/react";

const data = [
    { image: image01, name: "Roberta Araújo, profissional de TI", description: "“O Destino Poliglota me ensinou tanto as técnicas dos poliglotas como também a habilidade de reconhecer o que funciona pra mim no meu processo de aprendizado de idiomas”."},
    { image: image02, name: "Altino Teixeira, advogado e empresário", description: "“A mentoria me guiou em um processo de autoconhecimento muito bacana. Aprendi a ver o que funciona pra mim no meu aprendizado de línguas”"},
    { image: image03, name: "Natália Campos, servidora federal", description: "“O DP me colocou no caminho do aprendizado de duas línguas alvo, em simultâneo, de forma leve e respeitando meu jeito de ser. Hoje me comunico em ambas. Adorei essa vivência”."},
    { image: image04, name: "Fabiola Alves, advogada", description: "“O DP conseguiu me fazer reviver o aprendizado do inglês de uma maneira feliz, depois de tantas tentativas frustradas. Tô muito feliz no meu processo”. "},
    { image: image05, name: "Fabrício Penha, advogado", description: "“Já tava cansado dos cursos tradicionais que nunca conseguiram me fazer falar espanhol. Agora tô desfrutando de um processo que eu mesmo desenho e testo, com o acompanhamento dos tutores. E tô me tornando fluente. É uma grande vitória pra mim”."},
    { image: image06, name: "Mayra Jinkings, escritora, turismóloga e travel blogger", description: "“Finalmente encontrei um método que me respeita e isso tá sendo transformador. Tô aprendendo italiano ao mesmo tempo que aproveito a cultura italiana. Parece que tô vivendo lá, porque inseri o idioma no meu dia-a-dia. Destino Poliglota e método Vivência Poliglota aprovados”."},
    { image: image07, name: "Juliana Machado, professora e advogada", description: "“Sempre quis aprender francês e agora tô conseguindo. Existem técnicas pra aprender que eu nem imaginava e ainda tem o MTI pra me ajudar a enxergar o processo que criei com meus tutores. Muito bacana”"},
    { image: image08, name: "Carlos Carvalho, CTO e empresário", description: "“É muito legal poder finalmente conversar em espanhol e não em portunhol, graças às técnicas que comecei a aplicar e que aprendi no Destino Poliglota”."},
    { image: image09, name: "Gustavo Ferreira, profissional área da saúde", description: "“Sempre tive dificuldade com idiomas. Com os tutores aprendi a desenhar meu caminho e hoje me comunico em três línguas“"}
  ];
  
function Testimonials() {
  
  return (
    <div className="app-testimonials w-full grid justify-items-center">
        <img className="app-testimonials-bg h-full w-screen absolute" />
        <div className="section flex max-md:max-w-[300px]">
          <div className="h-full w-full place-content-evenly gap-2">
            
            <Carousel className="relative h-full w-full" transition={{ type: "spring" }} loop={true} autoplay={true} navigation={()=>{}} {...({} as React.ComponentProps<typeof Carousel>)}>
              {data.map((item, index) => (
                <div className="relative h-full min-w-[200px]"
                  key={index}
                >
                  <div className="grid app-testimonials-avatar absolute inset-0 h-full w-full content-center place-items-center">
                    <img src={item.image} alt={item.name} className="h-xs md:h-base max-w-xs" />
                    <Typography
                      variant="h1"
                      color="white"
                      className="text-2xl w-[70vw] md:max-w-[600px] text-center lg:text-5xl mt-10 mb-10"
                      {...({} as React.ComponentProps<typeof Typography>)}>
                        - {item.name}
                    </Typography>
                    <Typography
                      variant="h4"
                      color="white"
                      className="mb-12 opacity-95 w-[70vw] md:max-w-[600px] text-md lg:text-xl text-center"
                      {...({} as React.ComponentProps<typeof Typography>)}
                    >
                        {item.description}
                    </Typography>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
      </div>
    </div>
  );
}

export default Testimonials;
